export const IMAGE_SERVER_URL = process.env.REACT_APP_IMAGE_SERVER_URL;

export const PREVIOUS_STORAGE_URL_KEY = "PRODUCT_URL";

export const HOME_DEPOT_URL = "https://www.homedepot.com/";

export const redirectToProductPage = () => {
  const productPage = localStorage.getItem(PREVIOUS_STORAGE_URL_KEY);
  window.location.replace(productPage || HOME_DEPOT_URL);
};

export function mergeSearchParams(baseParams, newParams) {
  const searchParams = new URLSearchParams(baseParams);

  for (const pair of newParams) {
    if (!pair) continue;

    const [key, value] = pair.split("=");

    searchParams.set(key, value);
  }

  const paramsAsString = searchParams.toString();

  return paramsAsString ? `?${paramsAsString}` : "";
}

export function redirectSkiptiCheckoutFlow(path, params) {
  window.location.href =
    process.env.REACT_APP_SKIPTI_MAIN_DOMAIN + path + params;
}

export function redirectSkiptiDiscoverPage() {
  window.location.href = `${process.env.REACT_APP_SKIPTI_MAIN_DOMAIN}/discover`;
}